import React from 'react';
import { CHECKOUT_URL, images } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
export function FinalCta() {
  return <section id="cierre" aria-labelledby="cierre-titulo" className="relative isolate scroll-mt-8 overflow-hidden bg-ink-900" data-id="element-61" data-mp="19ez3lioa9i4t">
      <img src={images.courtBg} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" data-id="element-62" data-mp="15d41ibyj30pz" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(37,89,232,0.35),transparent_65%)]" data-id="element-63" data-mp="1jase6wifz1jy" />

      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:py-24" style={{
      paddingTop: "11px",
      paddingBottom: "17px"
    }} data-id="element-64" data-mp="1t2evnaldhwv5">
        <h2 id="cierre-titulo" className="font-display text-3xl uppercase leading-tight text-white sm:text-5xl" data-id="element-65" data-mp="223mfwor20x68">
          Tu próxima semana
          <span className="block text-ball-400" data-id="element-66" data-mp="1x5kwg2ppuvu8">puede ser diferente</span>
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate-300" data-id="element-67" data-mp="n6e3fhgh49u9">
          Padel Pro-Pack es el sistema completo para coaches de pádel que quieren trabajar con más
          orden, evidencia y libertad. Porque enseñar pádel no debería costarte todas tus horas libres
          del año.
        </p>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-ink-500 bg-ink-800/80 p-6 text-left backdrop-blur sm:p-8" data-id="element-68" data-mp="123mwcflfdlo3">
          <p className="font-display text-xl uppercase leading-tight text-white sm:text-2xl" data-id="element-69" data-mp="162dv0r5jhbdb">
            El Sistema Operativo del Coach de Pádel
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-70" data-mp="1fvl00awdapcv">
            12 Tomos Maestros + 5 Bonos. Abrís el PDF, elegís el nivel y la clase está armada.
          </p>

          <div className="mt-6 flex items-end gap-4 border-t border-ink-500 pt-6" data-id="element-71" data-mp="1pt8v51xvxyvk">
            <span className="text-lg font-semibold text-slate-500 line-through" data-id="element-72" data-mp="1ttro4zbilazc">$38 USD</span>
            <span className="font-display text-5xl leading-none text-ball-400" data-id="element-73" data-mp="3qufgxynvg0wd">$19</span>
            <span className="pb-1 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-74" data-mp="3lvko03w6wvyj">usd</span>
          </div>

          <CtaButton size="lg" className="mt-6 w-full" href={CHECKOUT_URL} data-id="element-75" data-mp="3i4puut6dett">
            👉 Quiero mi Padel Pro-Pack — $19 USD
          </CtaButton>

          <p className="mt-4 text-center text-xs font-semibold uppercase tracking-widest text-court-200" data-id="element-76" data-mp="3uuzc4wovwufv">
            Todos los niveles · Acceso inmediato
          </p>
        </div>

        <p className="mt-8 font-display text-lg uppercase text-court-200 sm:text-xl" data-id="element-77" data-mp="8fwglli32uwf">
          “Tu próxima clase puede ser la mejor que diste.” ⚡
        </p>

        <TrustRow className="mt-10" data-id="element-78" data-mp="if5887ph7xfm" />
      </div>
    </section>;
}